// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import { getExperienceListResponseTransformer, getRelatedArticlesResponseTransformer } from './transformers.gen';
import type {
  AddExperienceToFavoriteData,
  AddExperienceToFavoriteResponses,
  GetCityAroundData,
  GetCityAroundResponses,
  GetCityTagsData,
  GetCityTagsResponses,
  GetExperienceListData,
  GetExperienceListResponses,
  GetExperiencesFavoritesListData,
  GetExperiencesFavoritesListResponses,
  GetGuideInfoData,
  GetGuideInfoResponses,
  GetGuidesCommentsData,
  GetGuidesCommentsResponses,
  GetMovementTypesData,
  GetMovementTypesResponses,
  GetRelatedArticlesData,
  GetRelatedArticlesResponses,
  GetSightsData,
  GetSightsResponses,
  GetSigthsSeoData,
  GetSigthsSeoResponses,
  GetUserData,
  GetUserResponses,
  RemoveExperienceFromFavoriteData,
  RemoveExperienceFromFavoriteResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Получение списка типов перемещения
 */
export const getMovementTypes = <ThrowOnError extends boolean = false>(
  options?: Options<GetMovementTypesData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetMovementTypesResponses, unknown, ThrowOnError>({
    url: '/api/movement-types/',
    ...options,
  });

/**
 * Получение связанных статей журнала по городу
 */
export const getRelatedArticles = <ThrowOnError extends boolean = false>(
  options: Options<GetRelatedArticlesData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetRelatedArticlesResponses, unknown, ThrowOnError>({
    responseTransformer: getRelatedArticlesResponseTransformer,
    url: '/api/web/v1/articles/related/',
    ...options,
  });

/**
 * get sights
 */
export const getSights = <ThrowOnError extends boolean = false>(options?: Options<GetSightsData, ThrowOnError>) =>
  (options?.client ?? client).get<GetSightsResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/attractions/',
    ...options,
  });

/**
 * Получение комментариев гидов
 */
export const getGuidesComments = <ThrowOnError extends boolean = false>(
  options: Options<GetGuidesCommentsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetGuidesCommentsResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/attractions/{sightId}/comments/',
    ...options,
  });

/**
 * Получение информации о гиде
 */
export const getGuideInfo = <ThrowOnError extends boolean = false>(options: Options<GetGuideInfoData, ThrowOnError>) =>
  (options.client ?? client).get<GetGuideInfoResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/attractions/{sightId}/comments/notexists/',
    ...options,
  });

/**
 * City around
 */
export const getCityAround = <ThrowOnError extends boolean = false>(
  options: Options<GetCityAroundData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetCityAroundResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/cities/{city}/around/?has_attractions=true',
    ...options,
  });

/**
 * Получение тегов-достопримечательностей города
 */
export const getCityTags = <ThrowOnError extends boolean = false>(options: Options<GetCityTagsData, ThrowOnError>) =>
  (options.client ?? client).get<GetCityTagsResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/citytags/',
    ...options,
  });

/**
 * Получение списка экскурсий/туров в избранном
 */
export const getExperiencesFavoritesList = <ThrowOnError extends boolean = false>(
  options?: Options<GetExperiencesFavoritesListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetExperiencesFavoritesListResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/experiences/favorites/',
    ...options,
  });

/**
 * Удалить экспериенс из избранного
 */
export const removeExperienceFromFavorite = <ThrowOnError extends boolean = false>(
  options: Options<RemoveExperienceFromFavoriteData, ThrowOnError>,
) =>
  (options.client ?? client).delete<RemoveExperienceFromFavoriteResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/experiences/{experienceId}/favorite/',
    ...options,
  });

/**
 * Добавить экспериенс в избранное
 */
export const addExperienceToFavorite = <ThrowOnError extends boolean = false>(
  options: Options<AddExperienceToFavoriteData, ThrowOnError>,
) =>
  (options.client ?? client).put<AddExperienceToFavoriteResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/experiences/{experienceId}/favorite/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

/**
 * Get user data
 */
export const getUser = <ThrowOnError extends boolean = false>(options?: Options<GetUserData, ThrowOnError>) =>
  (options?.client ?? client).post<GetUserResponses, unknown, ThrowOnError>({ url: '/api/web/v1/me/', ...options });

/**
 * sigths seo
 */
export const getSigthsSeo = <ThrowOnError extends boolean = false>(options: Options<GetSigthsSeoData, ThrowOnError>) =>
  (options.client ?? client).get<GetSigthsSeoResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/seo/cities/{city}/sights/',
    ...options,
  });

/**
 * Experiences
 *
 * Main page experience list
 */
export const getExperienceList = <ThrowOnError extends boolean = false>(
  options?: Options<GetExperienceListData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetExperienceListResponses, unknown, ThrowOnError>({
    responseTransformer: getExperienceListResponseTransformer,
    url: '/api/web/v2/experiences/',
    ...options,
  });
